import { COST_CENTRE_TOTALS_BY_ID_PATH } from 'core/centrocosto/routes';
import { ACCOUNT_TOTALS_PATH } from 'core/cuenta/routes';
import { ConsolidatedReport } from 'core/empresa/models/ConsolidatedReport';
import { Liquidacion } from 'core/empresa/models/Liquidacion';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from 'shared/components';
import { Table } from 'shared/table';
import { formatDate, formatCurrency, formatParams } from 'shared/utils';

export const BusinessReportTable = (props: { reporte: ConsolidatedReport }) => {
  const navigate = useNavigate();

  const clickPeriodHandler = (item: Liquidacion) => {
    const date = moment(item.periodo);
    const path = props.reporte.centroCostoId
      ? COST_CENTRE_TOTALS_BY_ID_PATH.replace(':ccId', props.reporte.centroCostoId)
      : ACCOUNT_TOTALS_PATH;
    navigate({
      pathname: path,
      search: formatParams({ mes: date.month() + 1, anio: date.year() }),
    });
  };

  return (
    <Table
      thead={
        <tr>
          <td align="center" width="35%">
            Periodo
          </td>
          <td align="center" width="65%">
            Saldo
          </td>
        </tr>
      }
      tbody={
        <>
          {props.reporte?.liquidacion.map((item, index) => (
            <tr
              key={'consolidado' + item.periodo}
              data-testid={'consolidado-row-' + index}
            >
              <td className="align-right">
                <LinkButton onClick={() => clickPeriodHandler(item)}>
                  {formatDate(item.periodo, true)}
                </LinkButton>
              </td>
              <td className="align-right">{formatCurrency(item.saldoPesos)}</td>
            </tr>
          ))}
        </>
      }
    />
  );
};
